/* Grouping (ONAM skin, 18 Oct): federations made for the same brand are named after it ("IDFC X Airtel-demo",
   "IDFC X Pinelabs-Demo"; "Zee Bundesliga X FanCode", "Zee X CCI X Swiggy"). The brand is the first word of the
   name, before any " X " partner. On Choose a federation, a brand with more than one federation on the page shows
   as one group tile; opening it lists every federation of that brand (a search for the brand). */
export const fedBrand = (name: string = ""): string => {
  const lead = name.split(/\s+[x×]\s+/i)[0].trim();
  return (lead.split(/[\s_]+/)[0] || lead || "").trim();
};

export type FedTile<T> = { kind: "fed"; item: T } | { kind: "group"; brand: string; items: T[] };

/** The page's tiles: a group tile for each brand with two or more federations, in the order the brands first appear. */
export function fedTiles<T extends { name?: string }>(items: T[]): FedTile<T>[] {
  const key = (t: T) => fedBrand(t?.name).toLowerCase();
  const byKey = new Map<string, T[]>();
  for (const t of items) { const k = key(t); if (!byKey.has(k)) byKey.set(k, []); byKey.get(k)!.push(t); }
  const out: FedTile<T>[] = []; const done = new Set<string>();
  for (const t of items) {
    const k = key(t), all = byKey.get(k)!;
    if (all.length < 2) { out.push({ kind: "fed", item: t }); continue; }
    if (done.has(k)) continue;
    done.add(k); out.push({ kind: "group", brand: fedBrand(t?.name), items: all });
  }
  return out;
}

/** Federations of one brand, out of a search for it (the search matches names containing the word anywhere). */
export const ofBrand = <T extends { name?: string }>(items: T[], brand: string) =>
  items.filter((t) => fedBrand(t?.name).toLowerCase() === brand.toLowerCase());
